// /admin/eval — real route. Mirrors apps/web's app/admin/eval/page.tsx:
// fully self-contained 'use client' page (single + bulk eval runner against
// the already-ported admin-eval API, apps/server/src/routes/admin-eval.ts),
// no route params, lazy-imported directly per the porting convention
// (route-helpers.tsx). It renders the GenUI chat view
// (@/app/labs/genui/lab-chat-view, already ported) per active model tab.
// Registered from routes/admin.tsx under the `_admin` guard
// (routes/guards.tsx), parity with app/admin/layout.tsx:6.
import { lazy } from 'react';
import { createRoute } from '@tanstack/react-router';
import { adminRoute } from './guards';

const AdminEvalPage = lazy(() => import('@/app/admin/eval/page'));

export const adminEvalRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: '/admin/eval',
  component: AdminEvalPage,
});
